import axios from "axios";
import env from "../environment";
import { TOKEN_KEY } from "./authRefresh";

const apiPortalTransportador = axios.create({
  baseURL: env.API_PDT,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

// PO1-2445: o Bearer é injetado dinamicamente a cada request, lendo o token
// atual do storage — antes era fixado (e SEM "Bearer") no carregamento do
// módulo, o que podia mandar um token cru/stale numa request disparada antes
// do hooks/auth.js sincronizar os headers das instâncias.
apiPortalTransportador.interceptors.request.use((config) => {
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem(TOKEN_KEY) : null;
  if (token) {
    config.headers = config.headers || {};
    // axios 0.19 não normaliza o case do header; apaga a variante minúscula
    // antes de setar pra não mandar a versão velha herdada dos defaults.
    delete config.headers.authorization;
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// O interceptor de 401/refresh (attachAuthInterceptor) é anexado pelo
// hooks/auth.js, junto das demais instâncias (api, ApiHubBackend). PO1-1999:
// o tratamento de sessão é centralizado em services/authRefresh.js.

export default apiPortalTransportador;
